module.exports = __webpack_public_path__ + "static/media/styledcomponents.6e6afa15.png";